module.exports = __webpack_public_path__ + "img/our-04.171f757c.png";